import { LoginPhase } from 'navigation/models/login-phase';
import { TipoUsuario, Usuario } from 'user/models/Usuario';
import { IMPERSONATION_HOME_PATH } from 'user/routes';
import {
  IMPERSONACION_MENU_FUNCTIONALITY,
  IMPERSONATION_ACTOR_TYPES,
} from 'auth/constants/impersonationActors';

export function isImpersonationActor(tipoUsuario?: TipoUsuario): boolean {
  return (
    tipoUsuario != null &&
    (IMPERSONATION_ACTOR_TYPES as readonly TipoUsuario[]).includes(tipoUsuario)
  );
}

export function enrichAuthenticatedUser(user: Usuario): Usuario {
  return {
    ...user,
    funcionalidades: Array.from(
      new Set([
        ...(user.funcionalidades || []),
        'PERMITIR',
        ...(isImpersonationActor(user.tipoUsuario)
          ? [IMPERSONACION_MENU_FUNCTIONALITY]
          : []),
      ]),
    ),
  };
}

export function resolvePostLoginPath(
  tipoUsuario: TipoUsuario | undefined,
  loginPhase: LoginPhase,
): string | null {
  if (loginPhase !== LoginPhase.LOGGED_IN) {
    return null;
  }
  return isImpersonationActor(tipoUsuario) ? IMPERSONATION_HOME_PATH : '/';
}
